import { supabase } from './supabaseClient';
import { Indicator } from '../types';

export const fetchIndicators = async (): Promise<Indicator[]> => {
  const { data, error } = await supabase
    .from('indicators')
    .select('id, name_en, name_kh, category_id, canonical_unit, value_type, definition')
    .order('name_en', { ascending: true });
  if (error) throw error;
  return (data as Indicator[]) || [];
};
